export default {
  message: {
    success: "success",
    fail: "failure"
  },

  search:{
    total_order_count:'Total order count',//订单数总计
    total_amount_spent:'Total amount spent', //已花费金额总计
    created:'Created', //创建于
    order:'Order',//订单
    shipping_information:'Shipping information', //送货信息
    shipping_address:'Shipping address',//送货地址
    phone:'Phone number',//电话号码
    tracking_numbers:'Tracking numbers', //跟踪号码
    view_order:'View order', //跳转订单信息页面
    product_details:'Product details', //商品详情
    view_in_background:'View in background',//后台查看
    payment_breakdown:'Payment breakdown', //支付明细
    subtotal:'Subtotal', //小计
    shipping:'Shipping', //送货
    items:'Items', //个项目
    total:'Total', //总计
    payment_method:'Payment method', //付款方式
    paid_by_customer:'Paid by customer', //客户已支付
    not_found:'Not found',//无

    disputed_information:'Disputed information', //纠纷信息
    case_ID:"Case ID", //事件编号
    receiving_account:"Receiving account", //收款账号
    opened_on:"Opened on", //开立时间
    reason:"Reason", //争议理由
    status:"Status", //事件状态
    disputed_amount:"Disputed amount", //争议金额

  },


  navbar: {
    language: 'Language',
    logOut: 'Log Out', //退出登陆
    submit:'Submit', //提交
    label_options:'Label options', //标签选项
    close_other:'Close other', //关闭其他
    close_all:'Close all', //关闭所有
  },
  //登陆注册的不用管
  login: {
    title: 'Customer Login',
    logIn: 'Submit',
    register: 'Register'
  },
  register: {
    title: 'REGISTRATION DETAILS', //注册
    firstName: 'First name', //名
    lastName: 'Last name', //姓
    password: 'Password',
    checkPass: 'Confirm',
    captcha: 'Captcha',
    submit: 'Submit',
    reset: 'Reset', //重置
    cancel: 'Cancel',
  },
  password:{
    changePassword:'change Password', //修改密码
    enterOldPassword:'Enter old password', //输入旧密码
    newPassword:'Enter new password', //输入新密码
    confirmNewPassword:'Confirm new password', //确认新密码
  },

  http:{
    unauthorized:'Unauthorized, please log in again',//未授权，请重新登录
  },
  disputed_status:{
    'Waiting for seller response':'等待卖家回复',
    'Under review':'审查中',
    'Waiting for buyer response':'等待买家回复',
    'Resolved':'已完成',
  },
  disputed_reason:{
    'MERCHANDISE_OR_SERVICE_NOT_RECEIVED':'物品未收到',
    'MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED':'物品与描述不符',
    'UNAUTHORISED':'未经授权的交易',
    'CREDIT_NOT_PROCESSED':'未为客户处理信用交易',
    'DUPLICATE_TRANSACTION':'该交易是重复的',
    'INCORRECT_AMOUNT':'客户被收取了错误的金额',
    'PAYMENT_BY_OTHER_MEANS':'客户通过其他方式支付交易费用',
    'CANCELED_RECURRING_BILLING':'客户因取消定期计费而被错误收费',
    'OTHER':'其他',
  },
  disputed_base:{
    'BUYER':'买家',
    'SELLER':'卖家'
  }
}
